<script lang="ts">
    import type { Snippet } from "svelte";
    import type { HTMLButtonAttributes } from "svelte/elements";

    interface Props extends HTMLButtonAttributes {
        children: Snippet;
        color?: string;
    }

    const { children, color = "#fff8", ...props }: Props = $props();
</script>

<button
    {...props}
    style:--color={color}
    class={[
        "w-full rounded-[15px] bg-gradient-to-b from-(--color) to-(--color)/50 p-[10px] font-semibold text-white outline-[1.5px] outline-white/40 transition disabled:opacity-25",
        props.class,
    ]}
>
    {@render children()}
</button>
